{
  "salon-card": {
    "text": {
      "and-x-more": "a {{nr}} více",
      "points": "body"
    }
  }
}
